import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../../lib/api';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';

export const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('pera_admin_token');
    if (token) {
      navigate('/admin');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await adminApi.login({ email, password });
      localStorage.setItem('pera_admin_token', response.data.token);
      navigate('/admin');
    } catch (err) {
      setError('Geçersiz e-posta veya şifre');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-[#1a1a1a] flex items-center justify-center px-4"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/logo-vepera.png"
            alt="VE PERA Insaat"
            className="h-14 w-auto mx-auto mb-4 brightness-0 invert"
          />
          <p className="text-[#d1d1d6]">Admin Paneli</p>
        </div>

        <div className="bg-[#f2f2f7] p-8">
          <h2
            className="text-xl font-medium mb-6"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            Giriş Yap
          </h2>

          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">E-posta</label>
                <Input
                  data-testid="admin-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="input-premium"
                  placeholder="admin@perainsaat.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Şifre</label>
                <Input
                  data-testid="admin-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="input-premium"
                  placeholder="••••••••"
                />
              </div>

              {error && (
                <p data-testid="admin-login-error" className="text-red-600 text-sm">
                  {error}
                </p>
              )}

              <Button
                type="submit"
                data-testid="admin-login-submit"
                disabled={loading}
                className="w-full bg-[#041f60] hover:bg-[#b87333] text-white"
              >
                {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
